import { Box, Divider, Typography } from '@mui/material';
import { sharedStyles } from '../../utils/Style';
import {
  FrontendSettingsTab,
  SettingsTabDef,
} from '../../interfaces/Settings/SettingsTab';
import { FrontendSettingsTabs } from './FrontendSettingsTabs';

interface FrontendSettingsPageProps {
  tab: SettingsTabDef<FrontendSettingsTab>;
}

export const FrontendSettingsPage = (props: FrontendSettingsPageProps) => {
  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <FrontendSettingsTabs selectedTab={props.tab.kind} />
      <Box sx={{ p: 3 }}>
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
          {props.tab.name}
        </Typography>
        <Divider sx={{ mt: -2, mb: 1.5 }} />
        {props.tab.element}
      </Box>
    </Box>
  );
};
